import { NgModule } from '@angular/core';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { LinkButtonComponent } from './link-button/link-button.component';
import { SharedModule } from '../shared/shared.module';
import { ToggleContentComponent } from './toggle-content/toggle-content.component';
import { ArrowButtonsComponent } from './arrow-buttons/arrow-buttons.component';
import { IndentationButtonsComponent } from './indentation-buttons/indentation-buttons.component';
import { CounterButtonComponent } from './counter-button/counter-button.component';
import { SortButtonsComponent } from './sort-buttons/sort-buttons.component';
import { RemoveButtonComponent } from './remove-button/remove-button.component';
import { BackButtonComponent } from './back-button/back-button.component';



@NgModule({
    declarations: [ToggleButtonComponent, LinkButtonComponent, ToggleContentComponent, ArrowButtonsComponent, IndentationButtonsComponent, CounterButtonComponent, SortButtonsComponent, RemoveButtonComponent, BackButtonComponent],
    imports: [
        SharedModule
    ],
    exports: [
        ToggleButtonComponent,
        ToggleContentComponent,
        IndentationButtonsComponent,
        CounterButtonComponent,
        SortButtonsComponent,
        RemoveButtonComponent,
        BackButtonComponent
    ]
})
export class ButtonsModule { }
